import { propIn } from '../../../common/utils/immutableHelper';

export const getIsTaskComplete = (element) => !!propIn(['content', 'isComplete'], element);
